import { createClient } from "@supabase/supabase-js";

// These environment variables need to be set in your .env file
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("Missing Supabase environment variables");
}

// Regular client for user operations
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Admin client for server-side operations (only available in Node.js environment)
// This should only be used in server-side scripts, not in the browser
let supabaseAdmin = null;

// Check if we're in a Node.js environment (for scripts)
if (typeof window === "undefined" && process.env.SUPABASE_SERVICE_KEY) {
  supabaseAdmin = createClient(
    process.env.VITE_SUPABASE_URL || supabaseUrl,
    process.env.SUPABASE_SERVICE_KEY
  );
}

export { supabaseAdmin };
